export default () =>
  import(/* webpackChunkName: 'coffee/app/focus-wechat' */ './FocusWechat');
